import type { TripletSeries } from 'shared/types/analytics';

export function isTripletSeries(series: unknown[]): series is TripletSeries {
  return (
    series.length === 3 &&
    series.every(
      (entry) =>
        entry !== null && typeof entry === 'object' && 'value' in entry
    )
  );
}
